import { useContext, useState } from "react";

//Components
import {
  Box,
  Typography,
  Toolbar,
  AppBar,
  Tooltip,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import {
  WifiOff as WifiOffIcon,
  Wifi as WifiIcon,
  Room,
  Brightness4,
} from "@material-ui/icons";
import HamburgerMenu from "../HamburgerMenu";
import { Link } from "react-router-dom";
import { GiWalkieTalkie } from "react-icons/gi";
import { FaIdCard as PersonIcon } from "react-icons/fa";
import { DirectionsCar as DirectionsCarIcon } from "@material-ui/icons";
import { AiFillMessage } from "react-icons/ai";
import { FaBarcode } from "react-icons/fa";
import { CiBarcode } from "react-icons/ci";
import LicenseScanModal from "../LicenseScanModal/LicenseScanModal";
import RadioLogModal from "../RadioLogModal";
import DmvQueryModal from "../DMVQueryModal/DmvQueryModal";

//Contexts
import { UserContext } from "../../Contexts/UserContext";
import { IncidentsContext } from "../../Contexts/IncidentsContext";
import { INCIDENT_ACTIONS } from "../../Actions/IncidentActions";

//Styling
import { useStyles } from "../../Styles/styles";
import { incidentAlertColor } from "../../utils/utils";
import { checkRoles } from "../../utils/Roles";
import RegistrationScanModal from "../RegistrationScan/RegistrationScanModal";
import QuickButtons from "./QuickButtons";
import IncidentLinkButton from "../IncidentLinkButton";

const IncidentHeader = ({
  subscriptionServer,
  showVehicleSearch,
  setShowVehicleSearch,
  openChat,
  incidentNumber,
  incidentId,
  incidentIndex,
  setOfficerTime,
  handleCancelIncident,
  handleIncidentOpening,
  handleTicketOpening,
  handleVehicleOpening,
  inactive,
  user,
  incidentAddress,
  linkedIncidents,
  canEdit,
  handlePersonOpening,
  setShowQueryModal,
  selfOis,
  showRadioLog = true,
  incident,
  userPreferences,
  setUserPreferences,
  setPopper,
  incidentPeople,
  isOnIncident,
  socketConnected = true,
  setPausePolling,
}) => {
  const classes = useStyles();
  const { incidents, incidentDispatch } = useContext(IncidentsContext);
  const { toggleNightMode, nightMode, onlineState } = useContext(UserContext);
  const [show2728Modal, setShow2728Modal] = useState(false);
  const [showRadioModal, setShowRadioModal] = useState(false);
  const [showScanModal, setShowScanModal] = useState(false);
  const [showRegistrationScanModal, setShowRegistrationScanModal] =
    useState(false);

  const [queryType, setQueryType] = useState(null);

  const { ADD_OR_UPDATE_PIS, ADD_OR_UPDATE_VIS } = INCIDENT_ACTIONS;

  const handleAddPersonMatchToIncidentState = (
    incidentId,
    personIncidentSpecific
  ) => {
    incidentDispatch({
      type: ADD_OR_UPDATE_PIS,
      payload: {
        incidentId: incidentId,
        pis: personIncidentSpecific,
      },
    });
  };
  const handleAddVehicleMatchToIncidentState = (
    incidentId,
    vehicleIncidentSpecific
  ) => {
    incidentDispatch({
      type: ADD_OR_UPDATE_VIS,
      payload: {
        incidentIndex: incidentIndex,
        incidentId: incidentId,
        vis: vehicleIncidentSpecific,
      },
    });
  };

  const chatEnabled = user?.ori?.moduleOptions.find(
    mo => mo?.name === "Chat Option"
  );
  const stickyHeader =
    userPreferences?.stickyHeader === "true" ? "sticky" : "static";
  const addTopOffset =
    userPreferences?.stickyHeader === "true" &&
    userPreferences?.stickyTabs === "true";

  return (
    <AppBar
      position={stickyHeader}
      style={addTopOffset ? { top: "48px" } : {}}
      data-cy={"incident-header-bar"}
      className={classes.appBar}
    >
      <div style={{ display: "flex", flexDirection: "column", height: "auto" }}>
        <Toolbar style={{ width: "100%", padding: "0", paddingLeft: "24px" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            <Box
              id="online/offline-incident-number"
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
              width="fit-content"
            >
              <div
                className={
                  import.meta.env.VITE_FORCE_ONLINE === "true"
                    ? classes.forcedOnline
                    : classes.offline
                }
              >
                {!onlineState ? (
                  <Tooltip title="Currently OFFLINE">
                    <WifiOffIcon
                      data-cy="offline-indicator"
                      fontSize="large"
                      style={{ marginRight: "2rem" }}
                    />
                  </Tooltip>
                ) : socketConnected ? (
                  <Tooltip title="Currently online">
                    <WifiIcon
                      fontSize="large"
                      data-cy="online-indicator"
                      style={{ margin: "0 1vw", color: "#13c55a" }}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title="Subscription server offline">
                    <WifiIcon
                      fontSize="large"
                      data-cy="online-indicator"
                      style={{ margin: "0 1vw", color: "yellow" }}
                    />
                  </Tooltip>
                )}
              </div>
              <Typography
                className={classes.responsiveText}
                style={{
                  color: incidentAlertColor(
                    incidents[incidentIndex],
                    true,
                    true,
                    false
                  ),
                }}
                variant="h6"
                data-cy="incident-header-bar-incident-number"
                noWrap
              >
                {incidentNumber}
              </Typography>
            </Box>
            <QuickButtons
              selfOis={selfOis}
              disabled={!canEdit}
              isOnIncident={isOnIncident}
              setOfficerTime={setOfficerTime}
            />
            <Box
              id="27/28/43-buttons"
              flexGrow="2"
              justifyContent="space-around"
              display="flex"
              flexDirection="row"
              style={{ marginLeft: "2w", padding: "10px 0" }}
            >
              <Tooltip title="License Scan" placement="top">
                <IconButton
                  edge="start"
                  disabled={!canEdit}
                  onClick={() => {
                    setShowScanModal(true);
                  }}
                  className={classes.whiteHover}
                >
                  <FaBarcode style={{ fontSize: "2.5vw" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Registration Scan" placement="top">
                <IconButton
                  edge="start"
                  disabled={!canEdit}
                  onClick={() => {
                    setShowRegistrationScanModal(true);
                  }}
                  className={classes.whiteHover}
                >
                  <CiBarcode style={{ fontSize: "2.5vw" }} />
                </IconButton>
              </Tooltip>
              {checkRoles(user?.roleNames, "add_query_returns") && (
                <>
                  <Tooltip title="27 Query" placement="top">
                    <IconButton
                      edge="start"
                      disabled={!canEdit}
                      onClick={() => {
                        setQueryType({
                          id: 2,
                          name: "SNQ - 27 Name/DOB",
                          shortcode: "SNQ",
                        });
                        setShow2728Modal(true);
                      }}
                      className={classes.whiteHover}
                    >
                      <PersonIcon
                        style={{ fontSize: "2.5vw" }}
                        //fontSize="large"
                        //size="50"
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="28 Query" placement="top">
                    <IconButton
                      disabled={!canEdit}
                      edge="start"
                      onClick={() => {
                        setQueryType({
                          id: 1,
                          name: "SVQ - 28",
                          shortcode: "SVQ",
                        });
                        setShow2728Modal(true);
                      }}
                      className={classes.whiteHover}
                    >
                      <DirectionsCarIcon style={{ fontSize: "3vw" }} />
                    </IconButton>
                  </Tooltip>
                </>
              )}
              {showRadioLog && (
                <Tooltip title="Radio Log" placement="top">
                  <IconButton
                    disabled={!canEdit}
                    edge="start"
                    onClick={() => {
                      setShowRadioModal(true);
                    }}
                    className={classes.whiteHover}
                  >
                    <GiWalkieTalkie style={{ fontSize: "2.5vw" }} />
                  </IconButton>
                </Tooltip>
              )}
              {chatEnabled && (
                <Tooltip title="Chat" placement="top">
                  <IconButton
                    edge="start"
                    onClick={openChat}
                    className={classes.whiteHover}
                  >
                    <AiFillMessage style={{ fontSize: "2.5vw" }} />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box
              flexGrow="1"
              id="brightness-map-menu"
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              width="10%"
            >
              <Tooltip title="Night Mode" placement="top">
                <IconButton
                  edge="start"
                  onClick={toggleNightMode}
                  className={classes.whiteHover}
                  //size={"medium"}
                >
                  <Brightness4
                    style={{ fontSize: "2.5vw" }}
                    //fontSize="large"
                  />
                </IconButton>
              </Tooltip>
              <Tooltip title="Map" placement="top">
                <MenuItem
                  data-cy="incident-header-bar-map-link"
                  component={Link}
                  target="_blank"
                  rel="noreferrer"
                  to={`/mp/map/address/${incidentAddress?.id}/${incidentId}`}
                >
                  <Room
                    className={classes.hover}
                    style={{ fontSize: "2.5vw" }}
                  />
                </MenuItem>
              </Tooltip>
              <HamburgerMenu
                canEdit={canEdit}
                displayLogOut={false}
                handleCancelIncident={handleCancelIncident}
                handleIncidentOpening={handleIncidentOpening}
                handlePersonOpening={handlePersonOpening}
                handleTicketOpening={handleTicketOpening}
                handleVehicleOpening={handleVehicleOpening}
                inactive={inactive}
                setShowQueryModal={setShowQueryModal}
                incidentId={incidents[incidentIndex]?.id}
                incidentOriId={incidents[incidentIndex]?.ori?.id}
                handleAddPersonMatchToIncidentState={
                  handleAddPersonMatchToIncidentState
                }
                handleAddVehicleMatchToIncidentState={
                  handleAddVehicleMatchToIncidentState
                }
                userPreferences={userPreferences}
                setUserPreferences={setUserPreferences}
                showVehicleSearch={showVehicleSearch}
                setShowVehicleSearch={setShowVehicleSearch}
                incidentPeople={incidentPeople}
                subscriptionServer={subscriptionServer}
                setPausePolling={setPausePolling}
              />
            </Box>
          </Box>
        </Toolbar>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            marginLeft: "1vw",
          }}
        >
          {!!linkedIncidents && linkedIncidents?.length > 0 && (
            <p style={{ margin: 0, padding: 0 }}>Linked Incidents:&nbsp;</p>
          )}

          {linkedIncidents?.map((i, index) => {
            const isLast = index === linkedIncidents.length - 1;
            const moreThanOne = linkedIncidents.length > 1;
            return (
              <span key={index}>
                <IncidentLinkButton
                  handleIncidentOpening={handleIncidentOpening}
                  incident={i}
                  userRoles={user?.roleNames}
                />
                {!isLast && moreThanOne && <span>,&nbsp;</span>}
              </span>
            );
          })}
        </div>
      </div>
      {showRadioModal && (
        <RadioLogModal
          modalOpen={showRadioModal}
          setModalOpen={setShowRadioModal}
          incident={incident}
          incidents={[]}
        />
      )}
      <DmvQueryModal
        setPopper={setPopper}
        modalOpen={show2728Modal}
        setModalOpen={setShow2728Modal}
        incidentId={incidentId}
        defaultQuery={queryType}
      />
      <LicenseScanModal
        setPopper={setPopper}
        modalOpen={showScanModal}
        setModalOpen={setShowScanModal}
        user={user}
        onlineState={onlineState}
        incidentId={incidentId}
        incidentIndex={incidentIndex}
        incident={incident}
        incidentPeople={incidentPeople}
        nightMode={nightMode}
      />
      {showRegistrationScanModal && (
        <RegistrationScanModal
          setPopper={setPopper}
          modalOpen={showRegistrationScanModal}
          setModalOpen={setShowRegistrationScanModal}
          user={user}
          onlineState={onlineState}
          incidentId={incidentId}
          incidentIndex={incidentIndex}
          incident={incident}
          incidentPeople={incidentPeople}
          nightMode={nightMode}
        />
      )}
    </AppBar>
  );
};

export default IncidentHeader;
